<template>
  <div class="appointment-registration">
    <div class="appointment-registration-time">
      <span>就诊时段</span>
      <div>
        {{ dateInfo }}
      </div>
    </div>
    <div class="appointment-registration-info">
      <van-field
        v-for="(item, index) in appointmentInfo"
        :key="index"
        :label="item.label"
        :value="item.value"
        label-class="label-title"
        input-align="right"
        disabled
      />
      <van-radio-group
        v-if="qrtype !== '2'"
        v-model="appointmentType"
        direction="horizontal"
        class="appointment-registration-info-type"
        @change="typeChange"
      >
        <van-radio name="1">有卡</van-radio>
        <van-radio name="2">无卡</van-radio>
      </van-radio-group>
      <div class="appointment-registration-info-user">
        <van-field
          v-model="patientName"
          :disabled="appointmentType === '1'"
          label-class="label-title"
          label="就诊人"
          input-align="right"
          placeholder="请输入"
        />
        <van-field
          v-if="appointmentType === '1'"
          v-model="cardNo"
          label-class="label-title"
          label="卡号"
          input-align="right"
          placeholder="请输入"
          disabled
        />
        <van-field
          v-model="phone"
          type="number"
          label-class="label-title"
          label="手机号"
          input-align="right"
          placeholder="请输入"
          :rules="[
            {
              required: true,
              message: '请填写正确的手机号',
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            },
          ]"
        />
        <van-field
          v-if="appointmentType === '2'"
          v-model="idCard"
          label-class="label-title"
          label="身份证号"
          placeholder="请输入"
          :rules="[
            {
              required: true,
              message: '请填写正确的身份证号',
              pattern:
                /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            },
          ]"
          input-align="right"
        />
      </div>
      <div class="appointment-registration-info-tips">
        <h4>温馨提示</h4>
        <span
          >请于就诊当天携带就诊卡提前30分钟到院就诊，超时系统将重新排队，如需取消请提前一天操作！</span
        >
      </div>
      <ph-button @click="MedicalInsuranceMPIServiceClk" :disabled="isSubmitting" :title="isSubmitting ? '预约中...' : '确认预约'" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dateInfo: "",
      query: {},
      patientInfo: null,
      appointmentType: "1",
      patientName: "",
      cardNo: "",
      phone: "",
      idCard: "",
      appointmentInfo: [],
      qrtype: "1",
      msg: "请先绑卡",
      isSubmitting: false,
    };
  },
  created() {
    const { query } = this.$route;
    this.query = query;
    this.dateInfo = `${query.appointmentDate.replace(
      /(.{4})(.{2})(.{2})/,
      "$1年$2月$3日"
    )} ${query.appointmentTime}`;
    this.appointmentInfo = [
      { label: "医生名称", value: query.doctorName },
      { label: "医生职称", value: query.title },
      {
        label: "预约科室",
        value: query.appointOfficeName || query.departmentName,
      },
    ];
    this.sourceCode = query.sourceCode;
    this.qrtype = this.$route.query.qrtype || "1";
    if (query.qrtype === "2") {
      this.getQrCodePatientInfo();
    } else {
      this.getPatientInfo();
    }
  },
  methods: {
    ...mapActions("users", ["getUserBaseQrcodeInfo"]),
    getQrCodePatientInfo() {
      this.getUserBaseQrcodeInfo().then((res) => {
        this.patientName = res.name;
        this.cardNo = res.cardNo;
        this.phone = res.phone;
        this.idCard = res.idCard;
      });
    },
    getPatientInfo() {
      this.$http
        .post(this.$api.USER_BASE_INFO, {
          functionType: "1",
        })
        .then((res) => {
          this.patientInfo = res;
          this.patientName = res.patientName;
          this.cardNo = res.cardNo;
          this.phone = res.phone;
          this.idCard = res.idCard;
        })
        .catch((err) => {
          this.appointmentType = "2";
          // this.$toast("请先绑卡");
          // this.router.replace({
          //   name: "relative-card"
          // });
          console.log("err", err);
          this.msg = err.message;
        });
    },
    MedicalInsuranceMPIServiceClk() {
      if (this.isSubmitting) {
        return;
      }
      
      let reg =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!this.$regular.phone(this.phone)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      if (!this.idCard) {
        this.$toast("请输入身份证号");
        return;
      }
      // if (this.idCard && !reg.test(this.idCard)) {
      //   this.$toast("请输入正确的身份证号");
      //   return;
      // }
      // console.log(112);
      // return;
      if (!this.patientName) {
        this.$toast("请输入姓名");
        return;
      }
      
      this.isSubmitting = true;
      
      if (this.appointmentType === "1") {
        this.$http.post(this.$api.MEDICAL_INSURANCE_QUERY, {
          functionType: "1",
          patientId: this.patientInfo.patientId,
          ybsxbs: "1",
        }).then((res) => {
          if(res.payState == '0') {
            this.isSubmitting = false;
            this.$dialog
              .confirm({
                title: "提示",
                message: res.list.map(i => "您在"+i.orgName+"尚有"+i.itemName+i.amount+"元未结算，请及时结算；\n").join(""),
                cancelButtonText: "去缴清",
              })
              .then((e) => {
                this.isSubmitting = true;
                this.commit()
              }).catch(() => {
                location.href = res.ybUrl
              })
          } else {
            this.commit()
          }
        }).catch((err) => {
          this.isSubmitting = false;
          this.$toast("医保查询失败，请重试");
        })
      } else {
        this.commit()
      }
    },
    commit() {
      if (this.appointmentType === "1") {
        this.$http
          .post(this.$api.APPOINTMENT_REGISTER, {
            address: window.localStorage.getItem("cargo"),
            cardNo: this.cardNo,
            name: this.patientName,
            idCard: this.idCard,
            phone: this.phone,
            sourceCode: this.query.sourceCode,
            waitTime: this.query.appointmentTime,
            waitNumber: this.query.waitNumber,
            appointDoctorCode:
              this.query.appointDoctorCode || this.query.doctorId,
            appointDoctorName: this.query.doctorName,
            appointOfficeName:
              this.query.appointOfficeName || this.query.departmentName,
            outCallOfficeName: this.query.outCallOfficeName,
            officeAddress: this.query.officeAddress,
            appointOfficeCode:
              this.query.appointOfficeCode || this.query.departmentId,
            timeFrameCode: this.query.timeFrameCode,
            appointmentDate: this.query.appointmentDate,
            appointmentTime: this.query.appointmentTime,
            functionType: "1",
            appointType: this.appointmentType == "2" ? "2" : "1",
          })
          .then(() => {
            this.isSubmitting = false;
            this.$toast("预约成功");

            this.$phdialog
              .confirm({
                message: "请注意查收预约短信，按预约时间到院就诊。",
                confirmButtonText: "确认",
              })
              .then(() => {
                this.$router.replace({
                  name: "appointment-record",
                  query: {
                    qrtype: this.qrtype,
                    appointmentType: this.appointmentType,
                    name: this.patientName,
                    idCard: this.idCard,
                  },
                });
              })
              .catch((err) => {
                this.$router.replace({
                  name: "appointment-record",
                  query: {
                    qrtype: this.qrtype,
                    appointmentType: this.appointmentType,
                    name: this.patientName,
                    idCard: this.idCard,
                  },
                });
              });
          })
          .catch((err) => {
            this.isSubmitting = false;
            this.$toast("预约失败，请重试");
          });
      } else {
        this.$phdialog
          .confirm({
            message: `<P style="color:red">请确保填写的信息正确，否则无法取号就诊!</p><p>就诊人：${this.patientName}</p><p>手机号：${this.phone}</p><p>身份证：${this.idCard}</p>`,
            confirmButtonText: "确认",
            cancelButtonText: "返回修改",
          })
          .then((res) => {
            this.$http
              .post(this.$api.APPOINTMENT_REGISTER, {
                address: window.localStorage.getItem("cargo"),
                cardNo: this.cardNo,
                name: this.patientName,
                idCard: this.idCard,
                phone: this.phone,
                sourceCode: this.query.sourceCode,
                waitTime: this.query.appointmentTime,
                waitNumber: this.query.waitNumber,
                appointDoctorCode:
                  this.query.appointDoctorCode || this.query.doctorId,
                appointDoctorName: this.query.doctorName,
                appointOfficeName:
                  this.query.appointOfficeName || this.query.departmentName,
                outCallOfficeName: this.query.outCallOfficeName,
                officeAddress: this.query.officeAddress,
                appointOfficeCode:
                  this.query.appointOfficeCode || this.query.departmentId,
                timeFrameCode: this.query.timeFrameCode,
                appointmentDate: this.query.appointmentDate,
                appointmentTime: this.query.appointmentTime,
                functionType: "1",
                appointType: this.appointmentType == "2" ? "2" : "1",
              })
              .then(() => {
                this.isSubmitting = false;
                this.$toast("预约成功");

                this.$phdialog
                  .confirm({
                    message: "请注意查收预约短信，按预约时间到院就诊。",
                    confirmButtonText: "确认",
                  })
                  .then(() => {
                    this.$router.replace({
                      name: "appointment-record",
                      query: {
                        qrtype: this.qrtype,
                        appointmentType: this.appointmentType,
                        name: this.patientName,
                        idCard: this.idCard,
                      },
                    });
                  })
                  .catch((err) => {
                    this.$router.replace({
                      name: "appointment-record",
                      query: {
                        qrtype: this.qrtype,
                        appointmentType: this.appointmentType,
                        name: this.patientName,
                        idCard: this.idCard,
                      },
                    });
                  });
              })
              .catch((err) => {
                this.isSubmitting = false;
                this.$toast("预约失败，请重试");
              });
          })
          .catch(() => {
            this.isSubmitting = false;
          });
      }
    },
    typeChange(item) {
      if (item === "1") {
        if (!this.patientInfo) {
          this.appointmentType = "2";
          this.$toast(this.msg);
          // this.router.replace({
          //   name: "relative-card",
          // });
        } else {
          this.patientName = this.patientInfo.patientName;
          this.cardNo = this.patientInfo.cardNo;
          this.phone = this.patientInfo.phone;
          this.idCard = this.patientInfo.idCard;
        }
      } else {
        this.patientName = "";
        this.cardNo = "";
        this.phone = "";
        this.idCard = "";
      }
    },
  },
};
</script>

<style lang="less">
.appointment-registration {
  padding: 0.94rem;
  overflow: scroll;
  background: @primary-gray;

  &-time {
    padding: 0.88rem 0.94rem;
    color: white;
    background: @primary-blue;
    border-radius: 0.5rem 0.5rem 0 0;

    span {
      font-size: 0.88rem;
      opacity: 0.65;
    }
    div {
      margin-top: 0.2rem;
      font-weight: bold;
      font-size: 1.21rem;
    }
  }

  &-info {
    margin-bottom: 1rem;
    padding: 0 0.94rem 1rem 0.94rem;
    background: white;

    &-type {
      display: flex;
      justify-content: space-around;
      padding: 0.3rem 20%;
    }

    .van-cell {
      padding: 0.5rem 0;
    }
    .van-cell::after {
      right: 0;
      left: 0;
    }
    .van-field__control {
      font-size: 0.94rem;
    }
    .van-field__label {
      color: black;
      font-weight: 600;
    }
    .van-field__control:disabled {
      color: #555;
    }
    .label-title {
      font-size: 0.94rem;
    }

    &-user {
      border-bottom: 1px solid #ebedf0;
    }

    &-tips {
      padding: 0.94rem 0;
      font-size: 0.94rem;
      h4 {
        margin: 0;
      }
      span {
        color: gray;
        font-size: 0.88rem;
      }
    }
    button {
      width: 100%;
      margin: 0.5rem 0;
    }
  }
}
</style>
